import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FloatingMenuOption } from 'src/app/common/components/master-floating-menu/model/master-floating-model';
import { ColumnFilter, RequestData, SearchSort } from 'src/app/common/models/request-data.model';
import { SelectionModel } from '@angular/cdk/collections';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { LuckyDrawEntryService } from './lucky-draw-entry.service';
import { LdEntryModel } from './model/lucky-draw-entry.model';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { FilterListItemModel, SearchParam, SearchFilterComponent } from 'src/app/common/components/search-filter/search-filter.component';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { SystemSettingsService } from 'src/app/common/services/system-settings.service';
import { MatTableDataSource } from '@angular/material/table';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { MatSort, SortDirection } from '@angular/material/sort';
import { Router } from '@angular/router';
import { PermissionService } from 'src/app/auth/permission.service';
@Component({
    selector: 'app-lucky-draw-entry',
    templateUrl: './lucky-draw-entry.component.html',
    styleUrl: './lucky-draw-entry.component.scss',
    standalone: false
})
export class LuckyDrawEntryComponent {

  ldEntryList: LdEntryModel[] = [];
  showSearch: boolean = false;
  isLoading = true;
  IsDownloading = false;


  filter: FilterListItemModel[] = [
    {
      title: "Customer",
      column: "CONCAT_WS('',f_name, ' ', l_name )",

    },
    {
      title: "Email",
      column: "email",
      type: "string",
      operators: [
        { title: "is", operator: "=" },
        { title: "like", operator: "like" },

      ],
    },
    {
      title: "Member",
      column: "(ifnull(crm_customer_id,0) > 0)",
      type: "boolean",
      values: [
        { title: "Yes", value: "1" }, // Assuming you still want to filter by 'Yes' and 'No'
        { title: "No", value: "0" },
      ]
    },
    {
      title: "Order Source",
      column: "order_source",
      type: "list",
      operators: [
        { title: "is", operator: "=" },
      ],
      values: [
        { title: "Instore", value: "1" },
        { title: "Online", value: "2" },

      ]
    },
    
    {
      title: "Amount",
      column: "order_amount",
      type: "number",
      operators: [
        { title: "is", operator: "=" },
        { title: ">", operator: ">=" },
        { title: "<", operator: "<=" },

      ],
    },
    {
      title: "Draw",
      column: "lucky_draw_hdr_id",
      type: "list",
      values: []
    },
    {
      title: "Entry Date",
      column: "entry_time",
      type: "date",
    },
    {
      title: "Start Date",
      column: "ld_hdr.start_date",
      type: "date",

    },
    {
      title: "End Date",
      column: "ld_hdr.end_date",
      type: "date",

    },

  ];

  displayedColumns = ['item', 'name', 'member', 'source','amount', 'entry_time', 'draw', 'start_date', 'end_date'];
  pagingData = { length: 0, pageSize: 50, pageIndex: 0 };

  menuOption: FloatingMenuOption = {
    add: true,
    search: false,
    export: true,
    more: true
  }
  isHandset: boolean = false;
  searchColumFilter: ColumnFilter[] = [];
  columnSortData: SearchSort[] = [];
  selection = new SelectionModel<LdEntryModel>(true, []);
  selectedItem?: LdEntryModel;
  showRewardSummary: boolean = false;
  selectedRewardFilter: undefined;
  dateFormat: string;
  ldhdr = [];
  dataSource = new MatTableDataSource(this.ldEntryList);
  permission: any;
  constructor(private breakpointObserver: BreakpointObserver,
    private ldEntryService: LuckyDrawEntryService,
    private dialog: MatDialog,
    private snackBarService: SnackBarService,
    private router: Router,
    private systemSettingService: SystemSettingsService, private stateManagerService: StateManagerService,
    private permissionService: PermissionService
 ) {

    this.ldEntryList = [];
    this.dateFormat = systemSettingService.getDefaultDateFormat();
    this.permission = permissionService.getPagePermission('draw-entry');

  }

  /**
   * initilaize the device model
   */
  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isHandset = true;
      } else {
        this.isHandset = false;
      }
    });
    this.isLoading = false;
    this.IsDownloading = false;

    this.loadLDHdr();

  }


  /** 
 * Set the datasource
 */
  setDataSource(ldEntryList: LdEntryModel[]) {
    this.dataSource = new MatTableDataSource(ldEntryList);
    this.dataSource.sort = this.sort;
  }

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;
  ngAfterViewInit(): void {

    this.loadPreviousState();
    // this.loadData(); 
  }

  /**
   * loads the previous state if exists
   */
  loadPreviousState(): void {

    var previousState = this.stateManagerService.getState(this.constructor.name);

    if (previousState !== undefined && this.searchFilter != undefined) {

      if (previousState.state.search.filters.scope) {
        this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
        this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
      }

      if (previousState.state.search.sort != undefined && previousState.state.search.sort.length > 0) {
        this.setSortColumn(previousState.state.search.sort[0].column, previousState.state.search.sort[0].order);
      }

      this.searchColumFilter = JSON.parse(JSON.stringify(previousState.state.search.filters));
      this.searchFilter.setSearchFilter(this.searchColumFilter, true);

    } else {
      this.setSortColumn('entry_time', 'desc');
      this.loadData();
    }

  }

  /**
   * Sets the sort column
   * @param column 
   * @param direction 
   */
  setSortColumn(column: string, direction: SortDirection): void {
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: column, order: direction });
    this.sort.sort({
      id: column,
      start: direction,
      disableClear: false,
    });

    // this.sort.active=column;
    // this.sort.direction=direction;


  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.ldEntryList.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.ldEntryList);
  }


  /**
   * Create sort order
   * @returns sort criteria
   */
  getSort(): SearchSort[] {
    return this.columnSortData;
  }

  /**
   * Creates the column filter conditions based on search criteria
   * @returns Filter condions for columns
   */
  getColumnFilter(): ColumnFilter[] {

    return this.searchColumFilter;
  }
  /**
 * Creates the column filter conditions based on search criteria
 * if customers are selected and filtering for selected customer add filtered customer ids
 * @returns Filter condions for columns
 */
  getSearchParam(): SearchParam {

    let searchParam = JSON.parse(JSON.stringify(this.searchColumFilter));
    if (this.selectedRewardFilter !== undefined) {
      if (searchParam.advSearch !== undefined)
        searchParam.advSearch.push(this.selectedRewardFilter);
      else
        searchParam.advSearch = [this.selectedRewardFilter];
    }
    return searchParam;

  }
  /**
   * Builds the request data to be send to API
   * @returns Request Data
   */
  buildRequestData(): RequestData {
    let searchParam = this.getSearchParam();
    let requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: searchParam.freeSearch,
          advSearch: searchParam.advSearch,
          scope: {
            limit: this.pagingData.pageSize,
            offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
          }
        },
        sort: this.getSort(),
      }
    };

    return requestData;
  }
  /**
 * loads the ldhdr data based on the conditions
 */
  loadLDHdr(): void {
    let response = this.ldEntryService.getLuckyDrawHdr().subscribe(response => {
      if (response.status == 'SUCCESS') {
        this.ldhdr = response.data.ldHdr;
        this.filter[5].values = (this.ldhdr.map((ld: any) => {
          return { title: ld.name, value: ld.id };
        }));
      } else {
        let snackBarData: SnackBarData = {
          message: response.message,
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
      this.isLoading = false;
    });
  }
  /**
   * loads the ld entry data based on the conditions
   */
  loadData(): void {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    let response = this.ldEntryService.getList(requestData).subscribe(response => {
      if (response.status == 'SUCCESS') {
        //this.ldEntryList = response.data.rewards;
        this.setDataSource(response.data.ldEntry);
        this.pagingData.length = response.data.total_count;
        if (this.pagingData.length == 0) {
          let snackBarData: SnackBarData = {
            message: 'No data found. Please remove or change the filter if any.',
            title: 'No Data!!!',
            type: 'warn'
          }
          this.snackBarService.openSnackBar(snackBarData);
        } else {
          this.stateManagerService.setState(this.constructor.name, requestData);
        }
      } else {
        let snackBarData: SnackBarData = {
          message: response.message,
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
      this.isLoading = false;
    });

  }

  /**
   * On Search toggle button is clicked
   */
  toggleSearch(): void {
    this.showSearch = !this.showSearch
  }

  /**
   * On Add clicked
   * Show the dialog to enter new user
   */
  addClicked(): void {

    this.router.navigate(['reward-edit', 0]);
  }
  exportClicked() {
    let requestData = this.buildRequestData();
    this.IsDownloading = true;
    this.ldEntryService.downloadExcel(requestData)
      .subscribe({
        next: blob => {
          // Download logic
          this.IsDownloading = false;
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'lucky_draw_entry.csv'; // Adjust filename if needed
          link.click();
          window.URL.revokeObjectURL(url);
          this.isLoading = false;


        },
        error: error => {
          // Handle errors
          this.IsDownloading = false;
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.isLoading = false;
          // Display user-friendly error message to the user
        }
      }
      );
  }

  /**
   * 
   * @param event 
   * When page size is changed update paging data
   */
  onePageEvent(event: any): void {

    this.pagingData.pageIndex = event.pageIndex;
    this.pagingData.pageSize = event.pageSize;

    this.loadData();

  }




  /**
   * Set the column filter and reaload the daaa
   * @param columFilter 
   */
  onFilterApplied(columFilter: ColumnFilter[]): void {
    this.searchColumFilter = columFilter;
    this.loadData();

  }

  /**
   * On delete menu item selected
   * Confirm the user action and call the api to update
   */


  /**
   *  Set the sort param and relead the data
   * @param $event sort data
   * {"active": "email","direction": "asc"}
   *   
   */
  sortData($event: any): void {
    var sd = this.sort;
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: sd.active, order: sd.direction });
    this.loadData();
  }



  /**
* On entry selected
* @param entryInfo 
*/
  onRowSelected(entryInfo: LdEntryModel): void {
    this.selectedItem = entryInfo;
    this.showRewardSummary = true;
  }

}